<template>
    <div class="">
        <van-nav-bar left-arrow @click-left="back" style="" title="尾期贷待办列表" fixed/>
        <van-row style="margin: 46px 0 50px 0">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    :error.sync="error"
                    error-text="请求失败，点击重新加载"
                    @load="onLoad">
                <van-cell
                        style="padding: 20px"
                        v-for="item in list"
                        is-link
                        @click="toInfo(item.applyId)"
                        center>
                    <template>
                        <div style="display: flex">
                            <div style="width: 10%">
                                <span class="redeem">尾</span>
                            </div>
                            <div style="width: 90%">
                                <div style="display: flex;justify-content: space-between">
                                    <span style="font-weight: bold;">{{item.customerName}}</span>
                                    <span>{{item.applyDate}}</span>
                                </div>
                                <div>
                                    <span>所属机构：{{item.company}}</span>
                                </div>
                                <div>
                                    <span>申请金额：{{item.borrowAmount | formatMoney1}}</span>
                                </div>
                                <div>
                                    <span>申请期限：{{item.borrowTerm }} {{item.rateUnit|rateUnitCn}}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </van-cell>
            </van-list>
        </van-row>
    </div>
</template>

<script>

    import { getForeclosureApplyList } from '@/api/loanInfo'
    import { eventBus } from '../../vue/utils/eventBus'
    import store from '@/vue/store'

    export default {
        name: 'tail-list',
        components: {},
        data: function () {
            return {
                pageNo: 1,
                pageSize: 10,
                list: [],
                error: false,
                loading: false,
                finished: false
            }
        },
        mounted() {
            eventBus.$emit('showTabBar',false)
        },
        destroyed () {
        },
        methods: {
            routerUrl(url) {
                this.$router.push({path: url})
            },
            toInfo(index) {
                store.commit('SET_ISMONITORING', false)
                this.$router.push({path: '/tail/' + index})
            },
            back() {
                this.$router.go(-1)
            },
            onLoad() {
                let self = this
                //FIXME 获取当前角色
                let data = {
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                    productFlag: '1100112'
                }
                getForeclosureApplyList(data).then(res => {
                    self.loading = false;
                    //eventBus.$emit('tabbarInfo',res.data.length)
                    if (res.data.length > 0) {
                        self.list = self.list.concat(res.data)
                        if (res.count == self.list.length) {
                            self.finished = true;
                        } else {
                            self.pageNo++
                        }
                    } else {
                        self.finished = true
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .grid img {
        width: 28px;
        height: 28px;
    }
    .redeem {
        padding: 2px;
        border: 1px solid #FF6600;
        background: #FF5500;
        color: #fff;
        border-radius: 2px;
    }
</style>
